import { z } from 'zod';
import { uuidSchema } from '../common';
import { pageSchema } from './pagination';

/**
 * Activity / audit entries. `audit.view` (Admin) sees all entries; `audit.view_own` (Operations)
 * sees only entries where they are the actor — the conservative reading of "relevant activity
 * only" (OD-3). Request metadata (IP, user agent) is Admin-only.
 */
export const activityEntrySchema = z.object({
  id: z.number().int(),
  occurredAt: z.string(),
  actorType: z.enum(['admin', 'operations', 'system', 'integration']),
  actorId: uuidSchema.nullable(),
  action: z.string(),
  entityType: z.string().nullable(),
  entityId: z.string().nullable(),
  serviceId: uuidSchema.nullable(),
  changes: z.record(z.string(), z.unknown()).nullable(),
});
export type ActivityEntry = z.infer<typeof activityEntrySchema>;

export const activityPageSchema = pageSchema(activityEntrySchema);
